// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__mQ8s1","image":"Header_image__IZl_6","name":"Header_name__2t2py","info":"Header_info__3X2Pm","infoRow":"Header_infoRow__aEuYA"};